"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericTrackEvent = void 0;
const AppInsightsAnalyticsTracker_1 = require("./AppInsightsAnalyticsTracker");
const RudderStackAnalyticsTracker_1 = require("./RudderStackAnalyticsTracker");
const GenericTrackEvent = (eventDetails) => {
    const { object, objectType, action, properties } = eventDetails;
    const eventOrigin = "Web";
    const eventName = `${object} ${objectType} ${action} ${eventOrigin}`;
    (0, AppInsightsAnalyticsTracker_1.TrackEvent)(eventName, properties);
    (0, RudderStackAnalyticsTracker_1.TrackEvent)(eventName, properties);
};
exports.GenericTrackEvent = GenericTrackEvent;
//# sourceMappingURL=GenericEventTracker.js.map